module.exports = __webpack_public_path__ + "img/chuxingdaibuyongpin_shrz.7e857d6a.png";